import React, { useState } from "react";
import axios from "axios";
import "./forgotpassword.css";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [verificationCode, setVerificationCode] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [step, setStep] = useState(1);
    const [isLoading, setIsLoading] = useState(false); // ✅ Added loading state

    const navigate = useNavigate();

    const handleSendCode = async () => {
        setIsLoading(true);
        try {
            await axios.post("https://backend-n2zq.onrender.com/api/forgot-password", { email });
            toast.success("Verification code sent to your email!");
            setStep(2);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error sending code");
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmitEmail = (e) => {
        e.preventDefault();
        if (!email) {
            toast.warning("Please enter your email.");
            return;
        }
        handleSendCode();
    };

    const handleSubmitResetPassword = async (e) => {
        e.preventDefault();
        if (!verificationCode || !newPassword || !confirmPassword) {
            toast.warning("All fields are required.");
            return;
        }
        if (newPassword !== confirmPassword) {
            toast.error("Passwords do not match!");
            return;
        }

        setIsLoading(true);
        try {
            await axios.post("https://backend-n2zq.onrender.com/api/reset-password", {
                email,
                verificationCode,
                newPassword,
            });
            toast.success("Password reset successfully!");
            setTimeout(() => navigate("/signin"), 2000);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error resetting password");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="all">
            {step === 1 && (
                <div>
                    <form onSubmit={handleSubmitEmail}>
                        <h3>Forgot Password</h3>
                        <div className="input-container">
                        <input
                         type="email"
                         value={email}
                         onChange={(e) => setEmail(e.target.value)}
                         required
                        />
                       <label>Email</label>
                       </div>

                        
                        <button type="submit" disabled={isLoading}>
                            {isLoading ? "Sending..." : "Send Verification Code"}
                        </button>
                    </form>
                </div>
            )}

            {step === 2 && (
                <div className="all">
                    <form onSubmit={handleSubmitResetPassword}>
                        <h3>Reset Password</h3>
                        <div className="input-container">
                        <input
                            type="text"
                            value={verificationCode}
                            onChange={(e) => setVerificationCode(e.target.value)}
                            required
                        />
                        <label>Verification code</label>
                        </div>
                        
                        <div className="input-container">
                        <input
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />
                        <label >New password</label>
                        </div>
                        
                        <div className="input-container">
                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                        <label>Confirm new password</label>
                        </div>
                        
                        <button type="submit" disabled={isLoading}>
                            {isLoading ? "Resetting..." : "Reset Password"}
                        </button>
                    </form>
                </div>
            )}
            <div>
        <ToastContainer />

    </div>
</div>
        
    );
};

export default ForgotPassword;





